import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./All_activities.css";
import Heading_title from "../../common-components/common-title/heading-title/Heading_title";

const All_activities = () => {
  const activities = [
    {
      bigImg: "assets/images/about_us/all-activities/training.png",
      smallImg: "assets/images/about_us/all-activities/trainer.png",
      title: "Personal Training:",
      text: "One-on-one coaching tailored to your goals.",
    },
    {
      bigImg: "assets/images/about_us/all-activities/group.png",
      smallImg: "assets/images/about_us/all-activities/focus-group.png",
      title: "Group Sessions:",
      text: "Fun and energetic group workouts for all levels.",
    },
    {
      bigImg: "assets/images/about_us/all-activities/training.png",
      smallImg: "assets/images/about_us/all-activities/yoga.png",
      title: "Yoga & Meditation:",
      text: "Balance mind and body with guided yoga and mindfulness.",
    },
    {
      bigImg: "assets/images/about_us/all-activities/group.png",
      smallImg: "assets/images/about_us/all-activities/deadlift.png",
      title: "CrossFit & HIIT:",
      text: "High-intensity training for endurance and fat loss.",
    },
    {
      bigImg: "assets/images/about_us/all-activities/training.png",
      smallImg: "assets/images/about_us/all-activities/extracurricular-activities.png",
      title: "Sports Conditioning:",
      text: "Build strength, flexibility, and performance for athletes.",
    },
    {
      bigImg: "assets/images/about_us/all-activities/group.png",
      smallImg: "assets/images/about_us/all-activities/trainer.png",
      title: "Nutrition Guidance:",
      text: "Learn healthy eating habits to support your fitness journey.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  const handleActivityClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <section className="all-activities-section">
      <Container>
        <Heading_title
          title={"Our Specialisation"}
          subtitle={
            "Explore a wide range of sports programs designed for all skill levels"
          }
        />
        <Row className="align-items-center">
          {/* LEFT SIDE: Dynamic Big Image */}
          <Col lg={5} md={12}>
            <div className="activity-image-wrapper">
              <img
                src={activities[activeIndex].bigImg}
                alt={activities[activeIndex].title}
                className="activity-image"
              />
            </div>
          </Col>

          {/* RIGHT SIDE: Activity List */}
          <Col lg={7} md={12}>
            <div className="activity-list">
              {activities.map((item, index) => (
                <div
                  key={index}
                  className={`activity-item ${activeIndex === index ? "active" : ""
                    }`}
                  onClick={() => handleActivityClick(index)}
                >
                  <div className="icon-box">
                    <img
                      src={item.smallImg}
                      alt={item.title}
                      className="activity-icon"
                    />
                  </div>
                  <div className="text-box">
                    <h5>{item.title}</h5>
                    <p>{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default All_activities;
